import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { fade } from "../_shared/motion";
import { DOC_CATEGORIES } from "./constants";

export default function DocumentsSection() {
    return (
        <section className="py-16 md:py-20 bg-[#0E2A47] text-white" data-testid="referral-docs">
            <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
                <div className="max-w-2xl mb-12">
                    <p className="text-[12px] uppercase tracking-[0.2em] text-[#C8A24A] font-medium">
                        Step 3 · Required documents
                    </p>
                    <h2 className="mt-3 font-[Outfit] text-3xl md:text-4xl font-semibold tracking-tight text-white">
                        Documents we'll need at intake.
                    </h2>
                    <p className="mt-4 text-[15px] text-white/75 leading-relaxed">
                        At{" "}
                        <strong className="text-[#C8A24A] font-semibold">
                            Crossroads to Change Residential Treatment Center
                        </strong>
                        , please provide whatever is available. Missing
                        documents won't disqualify a referral — they help
                        us serve the youth safely from day one.
                    </p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                    {DOC_CATEGORIES.map((cat, i) => (
                        <motion.div
                            key={cat.title}
                            {...fade}
                            transition={{ ...fade.transition, delay: i * 0.04 }}
                            className="bg-white/5 border border-white/10 rounded-2xl p-6"
                            data-testid={`doc-${cat.title.toLowerCase().split(" ")[0]}`}
                        >
                            <div className="flex items-center gap-3 mb-4">
                                <div className="h-10 w-10 rounded-xl bg-[#C8A24A]/15 grid place-items-center text-[#C8A24A]">
                                    <cat.icon className="h-5 w-5" />
                                </div>
                                <h3 className="font-[Outfit] text-[17px] font-semibold tracking-tight text-white">
                                    {cat.title}
                                </h3>
                            </div>
                            <ul className="space-y-2 text-[14px] text-white/80">
                                {cat.items.map((item) => (
                                    <li key={item} className="flex items-start gap-2.5">
                                        <CheckCircle2 className="h-4 w-4 mt-0.5 text-[#C8A24A] shrink-0" />
                                        <span className="leading-relaxed">{item}</span>
                                    </li>
                                ))}
                            </ul>
                        </motion.div>
                    ))}
                </div>
                <p className="mt-8 text-[13.5px] text-white/60 max-w-3xl">
                    Sensitive records can be transmitted securely after we
                    connect. Please avoid uploading PHI, SSNs, or DFPS
                    documents in the form below.
                </p>
            </div>
        </section>
    );
}
